export default __webpack_public_path__ + "assets/bonaire-flag.png";